import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Price } from '../../common/components';
import { classNames } from '../../common/utils/classnames';
import { getFirstImage } from '../../common/utils/get-first-image';
import { getImageSrc } from '../../common/utils/get-image-src';
import { AspectRatioView } from '../../common/components/aspect-ratio-view';
import { useMobile } from '../../common/hooks/use-mobile';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { ProductLable } from '../../common/components/product-label';
import { PromotionLabel } from '../../common/components/promotion-label';
import ICON_AHAA_PROMOTION_LABEL from '../../common/images/icon-ahaa-promotion-label.png';
import { useDesignContext } from '../../design-provider';
export var WithImageGoods = function WithImageGoods(_ref) {
  var className = _ref.className,
    goods = _ref.goods;
  var mobile = useMobile();
  var _useDesignContext = useDesignContext(),
    designOnLink = _useDesignContext.designOnLink,
    productDefaultImage = _useDesignContext.productDefaultImage;
  var linkPath = designOnLink({
    linkType: 'product',
    linkParams: {
      name: goods.cskuName,
      id: goods.csku,
      csku: goods.csku
    }
  });
  return _jsxs("a", Object.assign({
    className: classNames('grid grid-cols-5 cursor-pointer', className),
    href: linkPath
  }, {
    children: [_jsxs(AspectRatioView, Object.assign({
      className: 'col-span-2'
    }, {
      children: [!goods.prominentFlag && !mobile && _jsx(PromotionLabel, {
        imgSrc: ICON_AHAA_PROMOTION_LABEL,
        className: 'z-1 w-12 h-5.5 absolute left-0 top-0',
        promotion: goods.promotionLabel
      }), _jsx(LazyLoadImage, {
        className: classNames('w-full h-full'),
        src: getImageSrc(getFirstImage(goods.customPictures, productDefaultImage))
      })]
    })), _jsxs("div", Object.assign({
      className: classNames('col-span-3 pl-2', 'cq-pc:pl-3')
    }, {
      children: [_jsx("div", Object.assign({
        className: classNames('hidden', 'cq-pc:text-sm cq-pc:font-medium cq-pc:text-ahaa-black-1 cq-pc:line-clamp-1')
      }, {
        children: goods.brandName
      })), _jsx("div", Object.assign({
        className: classNames('text-xs text-ahaa-black-1 line-clamp-1', 'cq-pc:mt-1 cq-pc:text-sm cq-pc:line-clamp-2 cq-pc:h-10')
      }, {
        children: goods.cskuName
      })), _jsxs("div", Object.assign({
        className: classNames('flex flex-col', 'cq-pc:mt-5 cq-pc:flex-row cq-pc:items-center')
      }, {
        children: [_jsx(Price, Object.assign({
          className: classNames('mt-1 text-ahaa-red-1', 'cq-pc:inline-flex cq-pc:items-center cq-pc:mt-0'),
          symbolClassName: classNames('text-sm font-medium', 'cq-pc:text-xs cq-pc:font-normal'),
          priceClassName: classNames('text-sm font-medium', 'cq-pc:text-xl cq-pc:font-semibold')
        }, {
          children: goods.salePrice
        })), goods.originPrice && goods.salePrice && +goods.originPrice > +goods.salePrice && _jsx(Price, Object.assign({
          className: classNames('block text-sm', 'cq-pc:inline cq-pc:pl-1'),
          symbolClassName: 'text-ahaa-black-3',
          priceClassName: 'text-ahaa-black-3',
          lineThrough: true
        }, {
          children: goods.originPrice
        }))]
      })), _jsx("div", Object.assign({
        className: classNames('hidden cq-pc:line-clamp-1')
      }, {
        children: _jsxs("div", Object.assign({
          className: classNames('mt-2 flex flex-wrap', 'h-3.5', 'cq-pc:h-4.5')
        }, {
          children: [_jsx(ProductLable, {
            labelData: goods.marketingLabel,
            className: classNames('mx-1 border border-ahaa-red-3 bg-ahaa-red-3 rounded-sm line-clamp-1 h-full text-white', 'px-0.5 py-0.25', 'cq-pc:px-1 cq-pc:py-0', {
              'text-[13px] leading-4': !mobile,
              'text-3xs': mobile
            })
          }), _jsx(ProductLable, {
            type: 'promotion',
            labelData: goods.disLabel,
            className: classNames('mx-1 border border-ahaa-red-3 rounded-sm h-full line-clamp-1 text-ahaa-red-3', 'px-0.5 py-0.25', 'cq-pc:px-1 cq-pc:py-0', {
              'text-[13px] leading-4': !mobile,
              'text-3xs': mobile
            })
          })]
        }))
      }))]
    }))]
  }));
};